<template>
  <LeftSidebar
    :visible="visible"
    :title="$lang.editActivity"
    bodyClass="overflow-y-hidden"
    titleClass="padding-x-16"
    :hasFooter="false"
    :hasHeaderRightIcon="false"
  >
    <div v-if="visible" class="height-percent-100">
      <ActivityForm
        :data="activityData"
        :submitMethod="updateActivity"
        mode="EDIT"
        @handleClose="handleClose"
      />
    </div>
  </LeftSidebar>
</template>

<script>
import { LeftSidebar } from "@/components/re-design";
import ActivityForm from "./ActivityForm.vue";
import { getActivity, updateActivity } from "@/services";
import { computed, inject, provide, ref, toRefs, watch } from "vue";
import { generateError } from "@/shared/utils";
export default {
  components: { LeftSidebar, ActivityForm },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  setup(props, { emit }) {
    // bind props
    const { visible, id } = toRefs(props);

    // bind emits
    const handleClose = () => emit("handleClose");

    // bind inject data
    const resourceName = inject("RESOURCE_NAME");
    const resourceValue = inject("RESOURCE_VALUE");

    // fetch data
    const loading = ref(false);
    const permissions = ref([]);
    const activityData = ref(null);
    const fetchData = async () => {
      try {
        loading.value = true;
        const response = await getActivity(
          resourceName.value,
          resourceValue.value,
          id.value
        );
        const { getData, permissionsData } = response;
        activityData.value = getData;
        permissions.value = permissionsData;
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };
    watch(visible, (value) => {
      if (value) {
        fetchData();
      }
    });

    // generate provide
    provide(
      "GET_LOADING",
      computed(() => loading.value)
    );

    // return data to be used in template
    return {
      visible,
      updateActivity,
      handleClose,
      activityData,
    };
  },
};
</script>
